export default "__VITE_ASSET__D1YE5djw__"